import React from 'react';
import { Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ClientForm from '../components/clients/ClientForm';

const CreateClientPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/clients');
  };

  const handleCancel = () => {
    navigate('/clients');
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 3 }}>
        <ClientForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </Box>
    </Container>
  );
};

export default CreateClientPage;